import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import { buildEditorialAlternates, buildEditorialCanonical, buildMagazineLinks } from '~/helpers/seo-helpers';
export default {
  name: 'Editorial',
  props: {
    type: {
      type: String,
      default: null
    },
    seo: {
      type: Object,
      required: true
    },
    page: {
      type: Number,
      default: null
    },
    totalPages: {
      type: Number,
      default: null
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  })), {}, {
    canonical() {
      var _ref5;
      var customCanonical = (_ref5 = this.seo) != null ? (_ref5 = _ref5.canonical) != null ? _ref5.url : _ref5 : _ref5;
      if (customCanonical) {
        return {
          rel: 'canonical',
          href: "".concat(customCanonical).concat(this.page && this.page !== 1 ? "?page=".concat(this.page) : '')
        };
      }
      return buildEditorialCanonical(this.baseURL, this.$route.path, this.page);
    },
    alternates() {
      var _ref3, _ref4;
      var customAlternates = (_ref4 = this.seo) != null ? (_ref4 = _ref4.alternates) != null ? (_ref4 = _ref4[0]) != null ? (_ref4 = _ref4.url) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4;
      var emptyAlternates = ((_ref3 = this.seo) != null ? _ref3.empty_alternates : _ref3) === 'true';
      if (customAlternates) {
        return this.seo.alternates.map(e => ({
          rel: 'alternate',
          hreflang: e.hreflang,
          href: e.url.url
        }));
      }
      if (emptyAlternates) {
        return [];
      }
      if (this.type === 'home') {
        return buildEditorialAlternates(this.baseURL, this.type, false, false, true);
      }
      return buildEditorialAlternates(this.baseURL, this.type, this.$route.params.slug, this.$route.params.alias !== this.type ? this.$route.params.alias : false);
    },
    previousPage() {
      return this.page && this.page > 1 ? this.page - 1 : null;
    },
    nextPage() {
      return this.page && this.page < this.totalPages ? this.page + 1 : null;
    }
  }),
  methods: {
    generatePageLink(page, type) {
      if (!page) {
        return [];
      }
      if (page === 1) {
        return [buildMagazineLinks({
          base: this.baseURL,
          alias: this.$route.path ? this.$route.path.slice(1) : '',
          type
        })];
      }
      return [buildMagazineLinks({
        base: this.baseURL,
        alias: this.$route.path ? this.$route.path.slice(1) : '',
        type,
        page
      })];
    }
  },
  head() {
    var _ref, _ref2;
    return {
      title: this.seo.meta_title ? "".concat(this.seo.meta_title, " | Maisons du Monde") : 'Maisons du Monde',
      link: [this.canonical, ...this.alternates, ...this.generatePageLink(this.nextPage, 'next'), ...this.generatePageLink(this.previousPage, 'prev')],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: ((_ref2 = this.seo) != null ? _ref2.meta_robots : _ref2) || 'noodp'
      }, {
        name: 'description',
        content: ((_ref = this.seo) != null ? _ref.meta_description : _ref) || ''
      }]
    };
  },
  render: h => h(null)
};